import { useState } from "react";
import {
    Dialog,
    DialogContent,
    DialogHeader,
    DialogTitle,
    DialogFooter,
} from "./ui/dialog";
import { Button } from "./ui/button";
import { Label } from "./ui/label";
import { Checkbox } from "./ui/checkbox";
import { RadioGroup, RadioGroupItem } from "./ui/radio-group";
import { FileDown } from "lucide-react";

// Dialog opsi export PDF Proposal: format detail/ringkas + tampilkan subtotal/diskon
export const ProposalPdfDialog = ({ open, onOpenChange, onExport }) => {
    const [format, setFormat] = useState("detail");
    const [showSubtotal, setShowSubtotal] = useState(true);
    const [showDiscount, setShowDiscount] = useState(true);

    function handleExport() {
        onExport({
            detailed: format === "detail",
            showSubtotal,
            showDiscount,
        });
        onOpenChange(false);
    }

    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogContent className="max-w-md" data-testid="proposal-pdf-dialog">
                <DialogHeader>
                    <DialogTitle>Opsi Export Proposal</DialogTitle>
                </DialogHeader>
                <div className="space-y-5">
                    <div>
                        <Label className="mb-2 block">Format Proposal</Label>
                        <RadioGroup value={format} onValueChange={setFormat} className="gap-2">
                            <label
                                className={`flex items-start gap-3 rounded-md border p-3 cursor-pointer ${
                                    format === "detail"
                                        ? "border-[#245B4B] bg-[#E9EFEA]"
                                        : "border-[#D1DCD8]"
                                }`}
                                data-testid="proposal-format-detail"
                            >
                                <RadioGroupItem value="detail" className="mt-0.5" />
                                <div>
                                    <div className="font-medium text-sm">Detail</div>
                                    <div className="text-xs text-[#6A9C89]">
                                        Dengan daftar nama pemeriksaan & tindakan per komponen
                                    </div>
                                </div>
                            </label>
                            <label
                                className={`flex items-start gap-3 rounded-md border p-3 cursor-pointer ${
                                    format === "ringkas"
                                        ? "border-[#245B4B] bg-[#E9EFEA]"
                                        : "border-[#D1DCD8]"
                                }`}
                                data-testid="proposal-format-ringkas"
                            >
                                <RadioGroupItem value="ringkas" className="mt-0.5" />
                                <div>
                                    <div className="font-medium text-sm">Ringkas</div>
                                    <div className="text-xs text-[#6A9C89]">
                                        Tanpa nama pemeriksaan — satu baris nama paket & total
                                    </div>
                                </div>
                            </label>
                        </RadioGroup>
                    </div>
                    <div>
                        <Label className="mb-2 block">Informasi Ringkasan</Label>
                        <div className="space-y-2">
                            <label className="flex items-center gap-3 cursor-pointer">
                                <Checkbox
                                    checked={showSubtotal}
                                    onCheckedChange={(v) => setShowSubtotal(!!v)}
                                    data-testid="proposal-show-subtotal"
                                />
                                <span className="text-sm">Tampilkan Subtotal</span>
                            </label>
                            <label className="flex items-center gap-3 cursor-pointer">
                                <Checkbox
                                    checked={showDiscount}
                                    onCheckedChange={(v) => setShowDiscount(!!v)}
                                    data-testid="proposal-show-discount"
                                />
                                <span className="text-sm">Tampilkan Diskon</span>
                            </label>
                        </div>
                        <div className="text-xs text-[#6A9C89] mt-2">
                            Harga Paket Final, Qty, dan Grand Total selalu ditampilkan.
                        </div>
                    </div>
                </div>
                <DialogFooter>
                    <Button
                        variant="outline"
                        onClick={() => onOpenChange(false)}
                        className="border-[#D1DCD8]"
                    >
                        Batal
                    </Button>
                    <Button
                        onClick={handleExport}
                        data-testid="proposal-export-btn"
                        className="bg-[#245B4B] hover:bg-[#1A4236] text-white"
                    >
                        <FileDown size={16} className="mr-2" /> Unduh PDF
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
};
